/** Up to two uppercase initials of a full name, e.g. "Jorge Rosario" → "JR". */
export const initialsOf = (fullName?: string, fallback = "A"): string => {
  const initials = fullName
    ?.trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase();
  return initials || fallback;
};
